import React, { useRef, useState } from "react";
import { Box, TextField, Typography } from "@mui/material";
import { useFormik } from "formik";
import { resetPasswordSchema } from "../../schemas";
import { toast } from "react-toastify";
import { useResetPasswordMutation } from "../../../../store/services/auth/auth.service";
import { IError } from "../../../../utils/getErrorMessage";
import { notifyError } from "../../../../utils/NotifyError";
import ReCAPTCHA from "react-google-recaptcha";
import RecaptchaDisclaimer from "../../../../Components/RecaptchaDisclaimer";
import ButtonComponent from "../../../../Components/ButtonComponent";
const RequestReset = () => {
	const [callResetPassword, { isLoading }] = useResetPasswordMutation();
	const [isLoadingReset, setIsLoadingReset] = useState(false);
	const recaptchaRef = useRef<ReCAPTCHA>(null);

	const handleOnSubmit = async (values: { email: string }) => {
		if (!recaptchaRef.current) {
			return notifyError({ error: "Recaptcha failed" } as IError);
		}
		setIsLoadingReset(true);
		let recaptchaToken: string | null = "";
		try {
			recaptchaToken = await recaptchaRef.current.executeAsync();
		} catch (e) {
			console.error(e);
		}

		callResetPassword({ ...values, recaptchaToken }).then(({ data, error }) => {
			if (data) {
				toast.success("We will send you a notification if your email exists!", { autoClose: 3000 });
			}
			if (error) {
				notifyError(error as IError);
			}
			setIsLoadingReset(false);
		});
	};

	const {
		handleSubmit,
		handleChange,
		errors,
		values: { email },
		dirty,
		isValid
	} = useFormik({
		validationSchema: resetPasswordSchema,
		initialValues: {
			email: ""
		},
		onSubmit: handleOnSubmit
	});

	return (
		<form onSubmit={handleSubmit} style={{ width: "100%" }}>
			<Typography variant={"h6"} className={"title"}>
				Reset Password
			</Typography>
			<Box mt={2} width={"100%"}>
				<Box mb={2} className={"input_wrapper"}>
					<Typography variant={"subtitle1"} fontWeight={"bold"}>
						Email
					</Typography>
					<TextField
						fullWidth
						type={"email"}
						value={email}
						name={"email"}
						onChange={handleChange}
						error={!!errors.email}
						helperText={errors.email}
					/>
				</Box>
			</Box>
			<Box width={"100%"}>
				<ButtonComponent
					fullWidth
					variant={"contained"}
					type="submit"
					disabled={(dirty && !isValid) || isLoading || isLoadingReset}
					loading={isLoading || isLoadingReset}
					text={"Reset Password"}
				/>
				<RecaptchaDisclaimer />
			</Box>
			<ReCAPTCHA
				sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY as string}
				size="invisible"
				ref={recaptchaRef}
				badge="bottomright"
			/>
		</form>
	);
};

export default RequestReset;
